/* eslint-disable react/jsx-no-target-blank */
import {useIntl} from 'react-intl'
import {SidebarMenuItem} from './SidebarMenuItem'
import { useAppSelector } from '../../../../../app/modules/store/Store'
import { selectAuth } from '../../../../../app/modules/auth/Auth.slice'
import { menuVisibilityService } from '../../../../../app/service/MenuVisibility.service'

const SidebarMenuMain = () => {
  const intl = useIntl()
  const auth = useAppSelector(selectAuth)
  const hideMenuOptions = menuVisibilityService.shouldHideMenuOptions(auth?.tokens?.idToken)

  return (
    <>
      {/* <SidebarMenuItem
        to='/dashboard'
        title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
        fontIcon='bi-house'
      /> */}
      {!hideMenuOptions && (
        <SidebarMenuItem
          to='/contacts'
          title={intl.formatMessage({id: 'MENU.DIRECTORY'})}
          fontIcon='bi-people'
        />
      )}
      {!hideMenuOptions && (
        <SidebarMenuItem
          to='/clients'
          title={intl.formatMessage({id: 'MENU.CLIENTS'})}
          fontIcon='bi-building'
        />
      )}
      {!hideMenuOptions && (
        <SidebarMenuItem
          to='/contracts'
          title={intl.formatMessage({id: 'MENU.CONTRACTS'})}
          fontIcon='bi-vector-pen'
        />
      )}
      <SidebarMenuItem
        to='/assets'
        title={intl.formatMessage({id: 'MENU.ASSETS'})}
        fontIcon='bi-cpu'
      />
      <SidebarMenuItem
        to='/reports'
        title={intl.formatMessage({id: 'MENU.REPORTS'})}
        fontIcon='bi-speedometer'
      />
      <SidebarMenuItem
        to='/tickets'
        title={intl.formatMessage({id: 'MENU.TICKETS'})}
        fontIcon='bi-wrench-adjustable-circle'
      />
    </>

    // <>
    //   <SidebarMenuItem
    //     to='/dashboard'
    //     icon='element-11'
    //     title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
    //     fontIcon='bi-app-indicator'
    //   />
    //   <SidebarMenuItem to='/builder' icon='switch' title='Layout Builder' fontIcon='bi-layers' />
    //   <div className='menu-item'>
    //     <div className='menu-content pt-8 pb-2'>
    //       <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Crafted</span>
    //     </div>
    //   </div>
    //   <SidebarMenuItemWithSub
    //     to='/crafted/pages'
    //     title='Pages'
    //     fontIcon='bi-archive'
    //     icon='element-plus'
    //   >
    //     <SidebarMenuItemWithSub to='/crafted/pages/profile' title='Profile' hasBullet={true}>
    //       <SidebarMenuItem to='/crafted/pages/profile/overview' title='Overview' hasBullet={true} />
    //       <SidebarMenuItem to='/crafted/pages/profile/projects' title='Projects' hasBullet={true} />
    //       <SidebarMenuItem
    //         to='/crafted/pages/profile/campaigns'
    //         title='Campaigns'
    //         hasBullet={true}
    //       />
    //       <SidebarMenuItem
    //         to='/crafted/pages/profile/documents'
    //         title='Documents'
    //         hasBullet={true}
    //       />
    //       <SidebarMenuItem
    //         to='/crafted/pages/profile/connections'
    //         title='Connections'
    //         hasBullet={true}
    //       />
    //     </SidebarMenuItemWithSub>

    //     <SidebarMenuItemWithSub to='/crafted/pages/wizards' title='Wizards' hasBullet={true}>
    //       <SidebarMenuItem
    //         to='/crafted/pages/wizards/horizontal'
    //         title='Horizontal'
    //         hasBullet={true}
    //       />
    //       <SidebarMenuItem to='/crafted/pages/wizards/vertical' title='Vertical' hasBullet={true} />
    //     </SidebarMenuItemWithSub>
    //   </SidebarMenuItemWithSub>
    //   <SidebarMenuItemWithSub
    //     to='/crafted/accounts'
    //     title='Accounts'
    //     icon='profile-circle'
    //     fontIcon='bi-person'
    //   >
    //     <SidebarMenuItem to='/crafted/account/overview' title='Overview' hasBullet={true} />
    //     <SidebarMenuItem to='/crafted/account/settings' title='Settings' hasBullet={true} />
    //   </SidebarMenuItemWithSub>
    //   <SidebarMenuItemWithSub to='/error' title='Errors' fontIcon='bi-sticky' icon='cross-circle'>
    //     <SidebarMenuItem to='/error/404' title='Error 404' hasBullet={true} />
    //     <SidebarMenuItem to='/error/500' title='Error 500' hasBullet={true} />
    //   </SidebarMenuItemWithSub>
    //   <SidebarMenuItemWithSub
    //     to='/crafted/widgets'
    //     title='Widgets'
    //     icon='element-7'
    //     fontIcon='bi-layers'
    //   >
    //     <SidebarMenuItem to='/crafted/widgets/lists' title='Lists' hasBullet={true} />
    //     <SidebarMenuItem to='/crafted/widgets/statistics' title='Statistics' hasBullet={true} />
    //     <SidebarMenuItem to='/crafted/widgets/charts' title='Charts' hasBullet={true} />
    //     <SidebarMenuItem to='/crafted/widgets/mixed' title='Mixed' hasBullet={true} />
    //     <SidebarMenuItem to='/crafted/widgets/tables' title='Tables' hasBullet={true} />
    //     <SidebarMenuItem to='/crafted/widgets/feeds' title='Feeds' hasBullet={true} />
    //   </SidebarMenuItemWithSub>
    //   <div className='menu-item'>
    //     <div className='menu-content pt-8 pb-2'>
    //       <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Apps</span>
    //     </div>
    //   </div>
    //   <SidebarMenuItemWithSub
    //     to='/apps/chat'
    //     title='Chat'
    //     fontIcon='bi-chat-left'
    //     icon='message-text-2'
    //   >
    //     <SidebarMenuItem to='/apps/chat/private-chat' title='Private Chat' hasBullet={true} />
    //     <SidebarMenuItem to='/apps/chat/group-chat' title='Group Chart' hasBullet={true} />
    //     <SidebarMenuItem to='/apps/chat/drawer-chat' title='Drawer Chart' hasBullet={true} />
    //   </SidebarMenuItemWithSub>
    //   <SidebarMenuItem
    //     to='/apps/user-management/users'
    //     icon='abstract-28'
    //     title='User management'
    //     fontIcon='bi-layers'
    //   />
    //   <div className='menu-item'>
    //     <a
    //       target='_blank'
    //       className='menu-link'
    //       href={process.env.REACT_APP_PREVIEW_DOCS_URL + '/docs/changelog'}
    //       href={'' + '/docs/changelog'}
    //     >
    //       <span className='menu-icon'>
    //         <KTIcon iconName='code' className='fs-2' />
    //       </span>
    //       <span className='menu-title'>Changelog {process.env.REACT_APP_VERSION}</span>
    //     </a>
    //   </div>
    // </>
  )
}

export {SidebarMenuMain}
